import React, { Component } from "react";

import Modal from "~/js/components/global/Modal";

const internals = {
  shuffleRsts: [["BTC"], ["BNG"], ["BBO"]],
  resorts: {
    BTC: {
      name: "Turks & Caicos",
      city: "Providenciales",
      country: "Turks & Caicos",
    },
    BNG: {
      name: "Negril",
      city: "negril",
      country: "jamaica",
    },
    BBO: {
      name: "Ocho Rios",
      city: "Ocho Rios",
      country: "jamaica",
    },
  },
};

//  select random for every resort set
const selectedRsts = internals.shuffleRsts.map((resorts) => {
  const random = (seed) => Math.floor(Math.random() * seed);

  return resorts[random(resorts.length)];
});

export default class FeaturedResorts extends Component {
  static defaultProps = {
    minimumRates: {},
    offerList: {},
    resortPercentageOff: [],
    resortsSummary: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      minimumRates: this.mapPropertiesBySelectedRsts(this.props.minimumRates),
      resortsOffers: this.mapPropertiesBySelectedRsts(this.props.offerList),
      resortsPercentageOff: this.getResortsPercentageOff(),
      offerTitle: "",
      offerDetails: "",
    };
  }

  mapPropertiesBySelectedRsts(property) {
    return selectedRsts.map((resort) => property[resort] || {});
  }

  getResortsPercentageOff() {
    return selectedRsts.map((resort) =>
      this.props.resortPercentageOff.find(
        (resortPercentage) => resortPercentage.resortCode === resort
      )
    );
  }

  getFeaturedResorts = () => {
    if (
      Object.keys(this.props.resortsSummary).length === 0 ||
      Object.keys(this.props.minimumRates).length === 0 ||
      Object.keys(this.props.resortPercentageOff).length === 0
    ) {
      return [];
    }

    return selectedRsts.map((rstCode, index) => {
      //const countdownImg =`${this.props.cdnURL}/specials/specials/countdown-bng`;

      return (
        <div
          className="col-sm-4 feature-resorts-flex-item"
          key={rstCode + index}
        >
          <div className="feature-resorts-item">
            <div className="feature-resorts-item-top">
              <i className="ic icon-new-logo-beaches" />
              <h3>{internals.resorts[rstCode].name}</h3>
              <p>
                {internals.resorts[rstCode].city},{" "}
                {internals.resorts[rstCode].country}
              </p>
            </div>
            

          {/* <picture>
              <source
                media="(min-width: 768px)"
                srcset={countdownImg + "-m.png"}
              />
              <source
                media="(max-width: 767px)"
                srcset={countdownImg + ".png"}
              />
              <img
                data-src={countdownImg + ".png"}
                alt="countdown"
                class={`opening-countdown ${rstCode.toLowerCase()}`}
              />
          </picture>*/}
       
            <img
              className="js-lazy img-responsive"
              src={
                this.props.cdnURL +
                "/specials/specials/resort-" +
                rstCode.toLowerCase() +
                ".jpg"
              }
              alt="Beaches resort"
            />
            <div className="price-value-container">
              <div className="price-value txt-center">
                <span className="price-value-3 adults from xl-4">
                  <span className="top-value">ADULTS</span>
                  <span className="bottom-value">FROM</span>
                </span>
                <div className="price-value-2-container xl-8">
                  <span className="price-value-2">
                    ${this.state.minimumRates[index][0].averageRate}
                  </span>
                  <span className="price-value-3 txt pp-pn">
                    <span className="top-value">PP/PN</span>
                    <span className="bottom-value">(USD)</span>
                  </span>
                </div>
              </div>
              <hr />
              <div className="price-value txt-center value-children">
                <span className="price-value-3 from xl-4">
                  <span className="top-value">KIDS</span>
                  <span className="bottom-value">FROM</span>
                </span>
                <div className="price-value-2-container xl-8">
                  <span className="price-value-2">
                    ${this.state.minimumRates[index][0].childRate}
                  </span>
                  <span className="price-value-3 txt pp-pn">
                    <span className="top-value">PP/PN</span>
                    <span className="bottom-value">(USD)</span>
                  </span>
                </div>
              </div>
            </div>
            <div className="price-save">
              <span className="sup price-save-inner">
                Get<span>UP to</span>
              </span>{" "}
              {
                this.state.resortsPercentageOff.find(
                  (resortPercentage) => resortPercentage.resortCode === rstCode
                ).amount
              }{" "}
              <span className="sup price-percent">%</span>
              <span className="sup sup-right price-save-inner">
                Off Rack<span>Rates</span>
              </span>
            </div>
            <div className="feature-resorts-item-bottom txt-center">
              <h4>Also Get These Promotions</h4>
              {this.getOffers(index, rstCode)}
            </div>
          </div>
          <a className="btn-view txt-center" href={"/deals/resort-specials/"}>
            View Rooms
          </a>
        </div>
      );
    });
  };

  getOffers = (index, rstCode) => {
    return this.state.resortsOffers[index].map((offer, offerIndex) => {
      return (
        <a
          className="btn-popup js-magnific-popup"
          href="#rst-offer-details"
          key={`${rstCode}-${offer.title}-${offerIndex}`}
          onClick={() => this.viewOfferDetails(offer.description, offer.title)}
        >
          {offer.title}
        </a>
      );
    });
  };

  viewOfferDetails(offerDetails, offerTitle) {
    this.setState({ offerDetails, offerTitle });
  }

  render() {
    return (
      <div>
        <div className="row feature-resorts-flex">
          {this.getFeaturedResorts()}
        </div>
        <Modal
          id="rst-offer-details"
          title={this.state.offerTitle}
          content={this.state.offerDetails}
        />
      </div>
    );
  }
}
